var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"myPage",attrs:{"id":"myPage"}},[_c('div',{staticClass:"title"},[_vm._v("マイページ")]),_c('MyPagePanel',{attrs:{"panelList":_vm.menuList},on:{"select":_vm.select}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }